import { render, staticRenderFns } from "./MessagingDescription.vue?vue&type=template&id=67c2774f&scoped=true&"
import script from "./MessagingDescription.vue?vue&type=script&lang=js&"
export * from "./MessagingDescription.vue?vue&type=script&lang=js&"
import style0 from "./MessagingDescription.vue?vue&type=style&index=0&id=67c2774f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c2774f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3744633428/src/vbc-messaging-10-dlc-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67c2774f')) {
      api.createRecord('67c2774f', component.options)
    } else {
      api.reload('67c2774f', component.options)
    }
    module.hot.accept("./MessagingDescription.vue?vue&type=template&id=67c2774f&scoped=true&", function () {
      api.rerender('67c2774f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/smsRegistrationComponents/MessagingDescription.vue"
export default component.exports